import { TCWUnexpectedError } from '@/plugins/TCWBaseError'
import * as DateUtil from '@/tcw/utils/DateUtil'
import Shimebi from '@/tcw/domain/Shimebi'

export default class Getsudo {
  private year: number
  private month: number

  constructor(year: number, month: number) {
    this.year = year
    this.month = month
  }

  public get yearValue(): number {
    return this.year
  }
  public get monthValue(): number {
    return this.month
  }

  public static of(year: string | number, month: string | number): Getsudo {
    const y = typeof year === 'string' ? Number(year) : year
    const m = typeof month === 'string' ? Number(month) : month
    if (Number.isNaN(y) || Number.isNaN(m)) {
      console.error(`${year}-${month}`)
      throw new TCWUnexpectedError('月度情報に数値以外が文字が指定されました')
    }

    // 締め日指定の場合
    return new Getsudo(y, m)
  }

  public static generateByDate(date: Date, shimebiInfo: Shimebi): Getsudo {
    let tmpDate = date
    // 月末締めでない場合は締め日を考慮して月度を算出
    if (shimebiInfo.isNextGetsudo(tmpDate)) {
      // 締め日以降の日は翌月度とする
      tmpDate = DateUtil.addDate(tmpDate, 1, 'M')
    }
    const [year, month] = [tmpDate.getFullYear(), tmpDate.getMonth() + 1]

    return new Getsudo(year, month)
  }

  public static now(shimebi: Shimebi = Shimebi.default()): Getsudo {
    return Getsudo.generateByDate(DateUtil.now(), shimebi)
  }

  public static last(shimebi: Shimebi): Getsudo {
    const now = Getsudo.now(shimebi)
    let lastMonthYear = now.yearValue
    let lastMonth = now.monthValue - 1
    if (lastMonth === 0) {
      lastMonth = 12
      lastMonthYear -= 1
    }
    return Getsudo.of(lastMonthYear, lastMonth)
  }

  public getDate(day?: number): Date {
    return new Date(this.year, this.month - 1, day ? day : 1)
  }

  public yearMonth(): { year: number; month: number } {
    return {
      year: this.year,
      month: this.month
    }
  }

  public isSameMonth(compareValue: Date | Getsudo, shimebiInfo: Shimebi): boolean {
    if (compareValue instanceof Date) {
      const compareGetsudo = Getsudo.generateByDate(compareValue, shimebiInfo)
      return this.year === compareGetsudo.year && this.month === compareGetsudo.month
    } else {
      return this.year === compareValue.year && this.month === compareValue.month
    }
  }

  public toString(): string {
    return `${this.year}/${this.month}`
  }
}
